import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getMenu = () => api.get("/menu").then((r) => r.data);
export const getOffers = () => api.get("/offers").then((r) => r.data);
export const getTestimonials = () => api.get("/testimonials").then((r) => r.data);
export const getBlogs = () => api.get("/blogs").then((r) => r.data);
export const getBlog = (slug) => api.get(`/blogs/${slug}`).then((r) => r.data);
export const getInstagram = () => api.get("/instagram/feed").then((r) => r.data);
export const createCheckout = (payload) => api.post("/checkout/session", payload).then((r) => r.data);
export const getPaymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);
export const getOrder = (sid) => api.get(`/orders/${sid}`).then((r) => r.data);

export const rupee = (n) => `\u20B9${Number(n).toLocaleString("en-IN")}`;

// Append Pexels compression params for faster image loads
export const px = (url, w = 800) => {
  if (!url || !url.includes("images.pexels.com")) return url;
  return url.includes("?") ? url : `${url}?auto=compress&cs=tinysrgb&w=${w}`;
};
